import { render, staticRenderFns } from "./Holdings.vue?vue&type=template&id=0f1f33b0&scoped=true"
import script from "./Holdings.vue?vue&type=script&lang=js"
export * from "./Holdings.vue?vue&type=script&lang=js"
import style0 from "./Holdings.vue?vue&type=style&index=0&id=0f1f33b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f33b0",
  null
  
)

export default component.exports